import { useAtom } from '@reatom/npm-react'

import { useTranslation } from '@root/shared/localization'
import { Dialog } from '@root/shared/ui-kit'

import { walletProfileModalAtom } from '../atoms'

import { WalletProfileContent } from './wallet-profile-content'

/**
 * One wallet's trading record, opened from its address anywhere it appears.
 *
 * The content is mounted only while there is a wallet, which is what makes it
 * fetch on opening rather than on app start: the resource loads on connect.
 */
export const WalletProfileModal = () => {
  const { t } = useTranslation()
  const [modal, setModal] = useAtom(walletProfileModalAtom)

  const title = t('wallet-profile.title')

  return (
    <Dialog
      describedBy={title}
      open={!!modal}
      onOpenChange={() => setModal(undefined)}
    >
      <Dialog.Header title={title} />

      {modal ? (
        <WalletProfileContent
          walletAddress={modal.walletAddress}
          network={modal.network}
        />
      ) : undefined}
    </Dialog>
  )
}
